// automatically generated by the FlatBuffers compiler, do not modify
/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */
import * as flatbuffers from 'flatbuffers'

import {SeqId} from './seq-id.js'

export class SetSeqId {
  bb: flatbuffers.ByteBuffer | null = null
  bb_pos = 0
  __init(i: number, bb: flatbuffers.ByteBuffer): SetSeqId {
    this.bb_pos = i
    this.bb = bb
    return this
  }

  static getRootAsSetSeqId(bb: flatbuffers.ByteBuffer, obj?: SetSeqId): SetSeqId {
    return (obj || new SetSeqId()).__init(bb.readInt32(bb.position()) + bb.position(), bb)
  }

  static getSizePrefixedRootAsSetSeqId(bb: flatbuffers.ByteBuffer, obj?: SetSeqId): SetSeqId {
    bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH)
    return (obj || new SetSeqId()).__init(bb.readInt32(bb.position()) + bb.position(), bb)
  }

  value(obj?: SeqId): SeqId | null {
    const offset = this.bb!.__offset(this.bb_pos, 4)
    return offset ? (obj || new SeqId()).__init(this.bb_pos + offset, this.bb!) : null
  }

  static startSetSeqId(builder: flatbuffers.Builder) {
    builder.startObject(1)
  }

  static addValue(builder: flatbuffers.Builder, valueOffset: flatbuffers.Offset) {
    builder.addFieldStruct(0, valueOffset, 0)
  }

  static endSetSeqId(builder: flatbuffers.Builder): flatbuffers.Offset {
    const offset = builder.endObject()
    return offset
  }

  static createSetSeqId(builder: flatbuffers.Builder, valueOffset: flatbuffers.Offset): flatbuffers.Offset {
    SetSeqId.startSetSeqId(builder)
    SetSeqId.addValue(builder, valueOffset)
    return SetSeqId.endSetSeqId(builder)
  }
}
